import { BusinessOnboardingDetails, HolderType } from '@nemuru-eng/js-api-client';

import { HoldersDetails } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/Holders/components/HolderDetails';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface HolderProps {
  loanId: string;
  id: string;
  holderType: HolderType;
  holders: BusinessOnboardingDetails['holders'];
  editModeAllowed?: boolean;
}

export const Holders = ({ loanId, id, holders, holderType, editModeAllowed }: HolderProps) => {
  const { isMobile } = useScreen();

  if (holders.length === 0) return <></>;

  return (
    <>
      <Font variant={'h3'} color={'title'} style={{ marginTop: '70px', marginBottom: isMobile ? '0px' : '4px' }}>
        <Text originalTextId tId={`${holderType}s`} />
      </Font>
      {holders
        .filter((holder) => holder.types.some((type) => type === holderType))
        .map((holder, i) => (
          <HoldersDetails
            loanId={loanId}
            id={id}
            editModeAllowed={editModeAllowed}
            holder={holder}
            holderType={holderType}
            index={i}
            boxProps={{ mt: 3 }}
          />
        ))}
    </>
  );
};
